<template>
  <v-navigation-drawer v-bind="$attrs" :mini-variant.sync="mini">
    <template v-slot:prepend>
      <v-toolbar flat dense v-if="!mini">
        <v-toolbar-title class="subtitle-1">Pages & Navigation</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon small @click="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>

      <v-btn class="mt-2" icon small @click="mini = !mini" v-else>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-divider v-show="!mini"></v-divider>

      <v-toolbar flat dense v-if="tabs.length" v-show="!mini">
        <v-tabs v-model="currentTab" color="secondary">
          <v-tab v-for="tab in tabs" :key="tab">{{ tab }}</v-tab>
        </v-tabs>
      </v-toolbar>

      <v-divider v-if="tabs.length" v-show="!mini"></v-divider>
    </template>

    <v-card
      flat
      tile
      :loading="$apollo.loading || drawer.loading"
      :disabled="$apollo.loading || drawer.loading"
      v-show="!mini"
    >
      <v-card-text v-if="activeTemplate && activeTemplate.pages" class="px-0">
        <v-tabs-items v-model="currentTab">
          <v-tab-item eager v-for="tab in tabs" :key="tab">
            <component
              :is="`${tab}-table`"
              :items="activeTemplate[tab]"
              :templateID="activeTemplate.id"
            ></component>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <template v-slot:append v-show="!mini">
      <v-divider></v-divider>

      <v-toolbar flat dense>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          :disabled="drawer.loading"
          @click="closeEditor()"
          >Close</v-btn
        >
      </v-toolbar>
    </template>
  </v-navigation-drawer>
</template>

<script>
import PagesTable from './PagesTable'
import MenusTable from './MenusTable'
import { activeTemplate } from '@/graphql/template.gql'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PageNavigation',
  components: {
    PagesTable,
    MenusTable
  },
  data: () => ({
    mini: false,
    currentTab: null,
    tabs: ['pages', 'menus']
  }),
  computed: {
    ...mapState('editor', ['drawer'])
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    }
  },
  methods: {
    ...mapActions('editor', ['closeEditor'])
  }
}
</script>
